<div class="save-and-continue-CTA-container">
  <button class="link" (click)="saveAndContinueLater()" type="button">
    {{ "REGISTRATION.SAVE_AND_CONTINUE.SAVE_AND_CONTINUE_CTA" | translate }}
  </button>
</div>
